/*******************************************
 * DOCUMENT READY HANDLER
 *******************************************/
document.addEventListener("DOMContentLoaded", function () {
  initializeMeasurementToggle();
  initializeModal();
  initializeValidation();
  initializeUnitToggle();
});

/*******************************************
 * MEASUREMENT TOGGLE
 *******************************************/
function initializeMeasurementToggle() {
  const radioButtons = document.querySelectorAll(".measurement-radio");
  const measurementsContainer = document.getElementById(
    "measurements-container"
  );
  const inputs = measurementsContainer.querySelectorAll('input[type="number"]');

  // First check if message container already exists
  let messageContainer = document.getElementById("send-later-message");

  // Only create new message container if it doesn't exist
  if (!messageContainer) {
    messageContainer = document.createElement("div");
    messageContainer.id = "send-later-message";
    messageContainer.className = "measurement-notice";
    messageContainer.style.display = "none";
    messageContainer.innerHTML =
      "<p>✓ After your order is confirmed, you can send measurements via WhatsApp (07769 431 970) or email them, along with your order number.</p>";
    document
      .querySelector(".measurement-options")
      .appendChild(messageContainer);
  }

  // Get the measuring kit info container (already in HTML)
  const measuringKitInfo = document.getElementById("measuring-kit-info");

  // Add function to handle the visibility state
  function updateMeasurementsVisibility(value) {
    if (value === "provide_now") {
      measurementsContainer.classList.add("active");
      inputs.forEach((input) => (input.required = true));
      messageContainer.style.display = "none";
      measuringKitInfo.style.display = "none";
    } else if (value === "email_later") {
      measurementsContainer.classList.remove("active");
      inputs.forEach((input) => (input.required = false));
      messageContainer.style.display = "block";
      measuringKitInfo.style.display = "none";
    } else if (value === "measuring_kit") {
      measurementsContainer.classList.remove("active");
      inputs.forEach((input) => (input.required = false));
      messageContainer.style.display = "none";
      measuringKitInfo.style.display = "block";
    }
  }

  // Check initial state when page loads
  const checkedRadio = document.querySelector(".measurement-radio:checked");
  if (checkedRadio) {
    updateMeasurementsVisibility(checkedRadio.value);
  }

  // Event listeners for radio changes
  radioButtons.forEach((radio) => {
    radio.addEventListener("change", function () {
      updateMeasurementsVisibility(this.value);
    });
  });
}

/*******************************************
 * MODAL FUNCTIONALITY
 *******************************************/
function initializeModal() {
  const modal = document.getElementById("measuring-modal");
  const modalButton = document.getElementById("open-modal-button");
  const closeButton = modal.querySelector(".modal-close");
  const modalOverlay = modal;
  const modalContainer = modal.querySelector(".modal-container");

  // Open modal handler
  function openModal() {
    modal.classList.add("is-active");
    modalContainer.classList.add("is-active");
    document.body.classList.add("modal-open");
  }

  // Close modal handler
  function closeModal() {
    modalContainer.classList.remove("is-active");
    setTimeout(() => {
      modal.classList.remove("is-active");
      document.body.classList.remove("modal-open");
    }, 300); // Match transition duration from CSS
  }

  // Event listeners
  modalButton?.addEventListener("click", openModal);
  closeButton?.addEventListener("click", closeModal);

  // Close on overlay click
  modalOverlay?.addEventListener("click", (event) => {
    if (event.target === modalOverlay) {
      closeModal();
    }
  });

  // Close on escape key
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape" && modal.classList.contains("is-active")) {
      closeModal();
    }
  });
}

/*******************************************
 * INPUT VALIDATION
 *******************************************/
function initializeValidation() {
  const inputs = document.querySelectorAll(".field__input");
  inputs.forEach((input) => {
    input.addEventListener("blur", function () {
      if (this.value) formatMeasurement(this);
    });
  });
}

// Keep measurement format when number is entered
function formatMeasurement(input) {
  if (input.value && !isNaN(input.value)) {
    const value = parseFloat(input.value);
    input.value = value.toFixed(1);
  }
}

/*******************************************
 * UNIT TOGGLE FUNCTIONALITY
 *******************************************/
function initializeUnitToggle() {
  // Check if buttons already exist
  if (document.querySelector(".unit-toggle")) {
    return; // Exit if buttons already exist
  }

  // Create unit toggle buttons
  const toggleContainer = document.createElement("div");
  toggleContainer.className = "unit-toggle";
  toggleContainer.innerHTML = `
    <button type="button" class="unit-btn" data-unit="cm">cm</button>
    <button type="button" class="unit-btn" data-unit="mm">mm</button>
    <button type="button" class="unit-btn" data-unit="in">in</button>
  `;

  // Insert after measurement instructions
  const instructions = document.querySelector(".measurement-instructions");
  instructions.after(toggleContainer);

  // Handle unit changes
  toggleContainer.addEventListener("click", function (e) {
    if (e.target.matches(".unit-btn")) {
      const unit = e.target.dataset.unit;
      const inputs = document.querySelectorAll(".field__input");

      inputs.forEach((input) => {
        const label = input.nextElementSibling;
        const currentText = label.textContent;
        label.textContent = currentText.replace(/(cm|mm|in)/, unit);
        input.placeholder = input.placeholder.replace(/(cm|mm|in)/, unit);
        input.name = input.name.replace(/(cm|mm|in)/, unit);
      });

      // Update active state of buttons
      document.querySelectorAll(".unit-btn").forEach((btn) => {
        btn.classList.remove("active");
      });
      e.target.classList.add("active");
    }
  });
}

/*******************************************
 * PAGE SHOW HANDLER (for pull-to-refresh)
 *******************************************/
window.addEventListener("pageshow", function (event) {
  // This includes pulls to refresh and back-forward cache restoration
  const checkedRadio = document.querySelector(".measurement-radio:checked");
  if (checkedRadio) {
    const measurementsContainer = document.getElementById(
      "measurements-container"
    );
    const inputs = measurementsContainer.querySelectorAll(
      'input[type="number"]'
    );
    const messageContainer = document.getElementById("send-later-message");
    const measuringKitInfo = document.getElementById("measuring-kit-info");

    if (checkedRadio.value === "provide_now") {
      measurementsContainer.classList.add("active");
      inputs.forEach((input) => (input.required = true));
      if (messageContainer) messageContainer.style.display = "none";
      if (measuringKitInfo) measuringKitInfo.style.display = "none";
    } else if (checkedRadio.value === "email_later") {
      if (messageContainer) messageContainer.style.display = "block";
      if (measuringKitInfo) measuringKitInfo.style.display = "none";
    } else if (checkedRadio.value === "measuring_kit") {
      if (messageContainer) messageContainer.style.display = "none";
      if (measuringKitInfo) measuringKitInfo.style.display = "block";
    }
  }
});
